<template>
	<div class="modal fade show" id="report_sale_detail" tabindex="-1" role="dialog" aria-labelledby="modalTitle">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="modalTitle">Báo cáo sale chi tiết {{renderCode()}}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">×</span>
					</button>
				</div>
				<div class="modal-body">
					<table class="table m-table m-table--head-bg-success">
						<thead>
							<tr>
								<th>#</th>
								<th>Ngày thêm</th>
								<th>Số tháng</th>
								<th>Khuyến mại</th>
								<th>Ngày hết hạn</th>
								<th>Thanh toán</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(d,idx) in this.detail">
								<th scope="row">{{idx + 1}}</th>
								<td>{{ renderCreatedAt(d.created_at) }}</td>
								<td>{{d.life_time}}</td>
								<td>{{d.bonus}}</td>
								<td>{{ renderExpiresDate(d.expires_at) }}</td>
								<td>{{ formatPay(d.pay) }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { Utilities } from "../../utilities";

	export default {
		props: ['from', 'to'],

		data(){
			return {
				detail: [],
				expires: []
			}
		},

		mounted() {
			let vm = this;

			$('#report_sale_detail').on('show.bs.modal', function (e) {
				let playerCode = $('#report_sale_detail').attr("playerCode");
				if(!playerCode) return;

				vm.fetchDetailSale(playerCode);
			})
		},

		methods: {
			fetchDetailSale: async function(code = null){
				if(!code) code = this.playerCode;
				let res = await axios.get("admin-panel/report/sale_detail/" + code + "?from="+this.from+"&to="+this.to);
				res = res.data;

				if(res.code == 0){
					this.detail = res.data;
					this.expires = this.calcExpiresDate(res.data);
				}
			},

			renderCreatedAt: function(created_at){
				return moment(created_at, "YYYY/MM/DD HH:mm:ss").format('DD/MM/YYYY');
			},

			formatPay: function(pay){
				return Utilities.currencyFormat(pay);
			},

			renderExpiresDate: function(expires_at){
				return moment(expires_at).format("DD/MM/YYYY");
			},

			// calcExpiresDate: function(detail){
			// 	let before = null;
			// 	let arr = [];

			// 	for(let i=0;i<detail.length;i++){
			// 		let createdAt = moment(detail[i].created_at, "YYYY/MM/DD HH:mm:ss");
			// 		let life = detail[i].life_time + detail[i].bonus;
					
			// 		if(before == null){
			// 			before = createdAt.add(life, 'M');
			// 		}else{
			// 			let expired = createdAt.diff(before, "s") > 0;
			// 			before = expired ? createdAt.add(life, 'M') : before.add(life, 'M');
			// 		}

			// 		arr[i] = before.format('DD/MM/YYYY');
			// 	}
	
			// 	return arr;
			// },

			renderCode: function(){
				let c = $('#report_sale_detail').attr("playerCode");
				return c ? c.toUpperCase() : "";
			}
		}
	}
</script>